<template>
  <div class="consumesolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0" >
                  <li v-for="(item,index) in difficultList" :key="index">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                  <div class="programBoxHead">
                     <ul v-if="flowList.length>0" class="listTop">
                         <li v-for="(item,index) in flowList" :key="index">
                           <dl>
                             <dt> <span v-html="item.name"></span></dt>
                             <dd v-html="item.content"></dd>
                           </dl>
                         </li>
                      </ul> 
                      <ul v-if="flowListx.length>0" class="listBottom">
                         <li v-for="(item,index) in flowListx" :key="index">
                           <dl>
                             <dt> <span v-html="item.name"></span></dt>
                             <dd v-html="item.content"></dd>
                           </dl>
                         </li>
                      </ul> 
                  </div>
                  <div class="programBoxCon">
                      <h1>全部关键流程电子数据存证保全，可以作为证明行为事实的证据使用</h1>
                      <p>
                            在消费金融行业，平台可通过智签电子签约平台进行用户实名认证、意愿确认、电子合同在线签署，并运用技术手段，固化消费金融业务中营销受理、贷前管理、贷中管理、放款交货、贷后管理等流程生成的电子数据的原始性、真实性，并连通消费金融业务生态，证明其关联关系，从而证明消费与借贷行为发生事实。同时利用区块链技术通过司法联盟链将数据同步至多家公证处、司法鉴定机构、仲裁机构以及互联网法院，保证电子数据可以作为证据被法院、仲裁所采信。并将相应的履约条款作为触发条件写入智能合约，满足触发条件后，自动执行。
                      </p>
                      <p>
                            消费金融解决方案提供实名认证、电子合同签署、全流程电子数据存证、数据密文托管、在线公证、在线鉴定等多元化的在线服务。并为消费金融平台的风险控制，绿色催收，商务拓展，对接商家，资产打包，证据准备等提供有力支撑，从而大幅度降低平台运营风险，保障企业的合法权益和经济利益，全面提升企业核心竞争力。
                      </p>
                  </div>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="(item,index) in guaranteeList" :key="index">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span v-html="item.title"></span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/kdyqsn_icon.png"),
          title:"异地签署难",
          content:"网贷行业的用户来自于全国各地，合同需要异地签署，成本高，效率低。"
        },
        {
          img:require("../../../assets/images/solution/htgln_icon.png"),
          title:"合同签署难",
          content:"大量的纸质合同或者电子合同，存储成本高，安全性差，管理困难。"
        },
        {
          img:require("../../../assets/images/solution/lyzxn_icom.png"),
          title:"履约执行难",
          content:"消费金融行业，由于客户群质量下沉，风控难以把握，逾期率与违约率较高，合同履约困难。"
        },
        {
          img:require("../../../assets/images/solution/jfdjjn_icon.png"),
          title:"纠纷解决难",
          content:"理赔、销售纠纷一直是保险行业的突出问题，大量的纠纷缺少关键的业务流程数据，导致解决困难。"
        },
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/znhyly_img.png"),
          icon:require('../../../assets/images/solution/znhy_nor_icon.png'),
          title:"智能合约履约",
          content:"通过履约条款，自动生成触发条件，写入区块链智能合约，进行履约管控，当满足触发条件时，合约自动执行。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution/judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
      ],
      flowList:[
        {
          name:"注册<br/>实名",
          content:'注册账号，同意服务协议，填写相关资料进行实名认证'
        },
        {
          name:"选购<br/>商品",
          content:'用户选定<br/>相关商品'
        },
        {
          name:"材料<br/>提交",
          content:'用户上传相关资料，如征信、还款能力证明、自动支付协议等'
        },
        {
          name:"风控<br/>审查",
          content:'平台进行风控审查、贷款审查、合规审查'
        },
        {
          name:"放款<br/>审批",
          content:'对于符合要求的用户，进行放款审批'
        },
        {
          name:"合同<br/>签署",
          content:'通过合同在线签署、公众平台接口、私有化部署等方式进行签约'
        },
      ],
      flowListx:[
        {
          name:'纠纷<br/>处理',
          content:'对于违约或者执行失败的合约，提供司法通道服务，进行在线纠纷解决'
        },
        {
          name:'贷款<br/>结清',
          content:'履约完成<br/>交易结束'
        },
        {
          name:'自动<br/>执行',
          content:'满足出发条件，智能合约自动执行，如自动还款'
        },
        {
          name:'商家<br/>发货',
          content:'商家收到货款后发货'
        },
        {
          name:'平台<br/>放款',
          content:'消费金融平台进行放款，资金划转'
        },
        {
          name:'创建<br/>履约',
          content:'根据履约条款，生成出发调教，写入智能合约'
        },
      ]
    }
  }
}
</script>
<style lang="scss" >
.consumesolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
      padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          .programBoxHead{
            width: 100%;
            ul{
              width:100%;
              display: block;
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              li{ 
                text-align:center;
                position: relative;
                dl{
                width: 130px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-direction: column;
                   dt{
                     width:60px;
                    height: 60px;
                    display: flex;
                    justify-content:center;
                    border-radius: 50%;
                    align-items: center;
                    text-align: justify;
                    background: #B41C2E;
                    margin-bottom: 13px;
                   }
                   dd{
                      font-size: 14px;
                      color: #787878;
                      line-height: 22px;
                      text-align: justify;
                   }
                }
                span{
                    color:#fff;
                    opacity: 0.8;
                }
              }
              li:after{
                  content: '';
                  display: block;
                  position: absolute;
                  right: -109px;
                  top: 23px;
                  width: 137px;
                  height: 20px;
                  background:url("../../../assets/images/solution/line_r_img.png")no-repeat;
                  background-size:100%;
              }
              li:last-child:after{
                background:none;
              }
            }
            .listBottom{
              margin-top: 74px;
                margin-bottom: 60px;
              li{
                position: relative;
              }
              li:last-child:before{
                 content: '';
                  display: block;
                  position: absolute;
                  left: 56px;
                  top: -79px;
                  width: 16px;
                  height: 137px;
                  background:url("../../../assets/images/solution/line_d_img.png")no-repeat;
                  background-size:100%;
              }
              li:nth-child(3)::before{
                  content: '';
                  display: block;
                  position: absolute;
                      left: -364px;
                  top: -50px;
                  width: 432px;
                  height: 44px;
                  background:url("../../../assets/images/solution/guai.png")no-repeat;
                  background-size: 100%;
              }
              li:nth-child(1):after{
                  width: 0;
              }
              li:after{
                background:url("../../../assets/images/solution/line_l_img.png")no-repeat;
              }
            }
          }
          .programBoxCon{
            h1{
              width:100%;
              height: 60px;
              line-height: 60px;
              text-align: center;
              font-size: 18px;
              font-weight: normal;
              color: #787878;
              background: #EBEBEB;
              margin-bottom: 16px;
            }
            p{
              font-size: 14px;
              color:#787878;
              line-height: 26px;
              text-indent: 2em;
              text-align: justify;
              margin-bottom: 20px;
            }
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom:6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/znhy_hov_icon.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
